"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultReviewImportProps = exports.defaultProps = exports.defaultPageProps = exports.defaultIdentifyProps = void 0;

var _pickBy3 = _interopRequireDefault(require("lodash/pickBy"));

var _get3 = _interopRequireDefault(require("lodash/get"));

var _cookieUtils = require("angieslist-app-platform/lib/common/utils/cookieUtils");

var getAdvertiserStatusFromState = function getAdvertiserStatusFromState(state) {
  var isAdvertiser = (0, _get3["default"])(state, "serviceProviderCache.".concat(state.serviceProviderId, ".isAdvertiser"));

  if (typeof isAdvertiser === 'undefined') {
    return undefined;
  }

  if (isAdvertiser) {
    return 'Advertiser';
  }

  return 'NonAdvertiser';
};

var getUserIdFromCookie = function getUserIdFromCookie() {
  if (typeof window !== 'undefined') {
    var maybeCookie = (0, _cookieUtils.getCookie)('ajs_user_id');
    return maybeCookie && maybeCookie !== 'null' ? maybeCookie : undefined;
  }

  return undefined;
};

var defaultProps = (0, _pickBy3["default"])({
  userId: '[[user.userInfo.response.userId]]',
  serviceProviderId: '[[serviceProviderId]]',
  href: typeof window !== 'undefined' ? window.location.href : null,
  pathName: typeof window !== 'undefined' ? window.location.pathname : null,
  advertisingStatus: getAdvertiserStatusFromState
});
exports.defaultProps = defaultProps;
var defaultReviewImportProps = (0, _pickBy3["default"])({
  userId: getUserIdFromCookie,
  spId: '<<attributes.data-track-spId.value>>',
  href: typeof window !== 'undefined' ? window.location.href : null,
  pathName: typeof window !== 'undefined' ? window.location.pathname : null,
  advertisingStatus: getAdvertiserStatusFromState,
  serviceProviderExperience: '<<attributes.data-track-brand.value>>'
});
exports.defaultReviewImportProps = defaultReviewImportProps;
var defaultPageProps = (0, _pickBy3["default"])({
  userId: '[[user.userInfo.response.userId]]',
  serviceProviderId: '[[serviceProviderId]]',
  advertisingStatus: getAdvertiserStatusFromState
});
exports.defaultPageProps = defaultPageProps;
var defaultIdentifyProps = {
  userId: '[[user.userInfo.response.userId]]'
};
exports.defaultIdentifyProps = defaultIdentifyProps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-office-app-common/lib/analytics/analyticsDefaultProperties.js
// module id = 1921
// module chunks = 25